module.exports = __webpack_public_path__ + "static/media/Tyler Perkins Headshot_1727346680573.2fc42629.jpeg";